import React, { useState } from "react";
import axios from "axios";
import { API_BASE } from "../../config/apiBase";

const API = `${API_BASE}/manager/website`;

export default function HotelEditForm({ hotel, onSave, auth }) {
  const [form, setForm] = React.useState({ ...hotel });
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState("");
  const [success, setSuccess] = React.useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    setSuccess("");
    try {
      // PATCH/PUT to backend (to be implemented)
      const res = await axios.put(`${API}/hotel`, form, auth());
      setSuccess("Hotel info updated successfully");
      if (onSave) onSave(res.data?.data);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to update hotel info");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="hotel-edit-form">
      <div className="form-heading">Hotel Information</div>
      <div className="form-row">
        <div className="form-group">
          <label>Name</label>
          <input name="name" value={form.name || ''} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Category</label>
          <input name="category" value={form.category || ''} onChange={handleChange} />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group" style={{ flex: 1 }}>
          <label>Description</label>
          <textarea name="description" value={form.description || ''} onChange={handleChange} rows={2} />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label>Address</label>
          <input name="address" value={form.address || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>City</label>
          <input name="city" value={form.city || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>State</label>
          <input name="state" value={form.state || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Country</label>
          <input name="country" value={form.country || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Postal Code</label>
          <input name="postal_code" value={form.postal_code || ''} onChange={handleChange} />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label>Phone</label>
          <input name="phone" value={form.phone || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input name="email" value={form.email || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Website</label>
          <input name="website" value={form.website || ''} onChange={handleChange} />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label>Check-in Time</label>
          <input name="check_in_time" value={form.check_in_time || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Check-out Time</label>
          <input name="check_out_time" value={form.check_out_time || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Floors</label>
          <input name="total_floors" type="number" value={form.total_floors || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Rooms</label>
          <input name="total_rooms" type="number" value={form.total_rooms || ''} onChange={handleChange} />
        </div>
      </div>
      <div className="form-heading" style={{marginTop:24}}>Booking Page Display</div>
      <div className="form-row">
        <div className="form-group">
          <label>Rating (1.0 - 10.0)</label>
          <input name="rating" type="number" step="0.1" min="1" max="10" value={form.rating || ''} onChange={handleChange} placeholder="e.g. 8.7" />
        </div>
        <div className="form-group">
          <label>Review Count</label>
          <input name="review_count" type="number" min="0" value={form.review_count || ''} onChange={handleChange} placeholder="e.g. 1234" />
        </div>
        <div className="form-group">
          <label>Distance from Centre</label>
          <input name="distance_from_center" value={form.distance_from_center || ''} onChange={handleChange} placeholder="e.g. 2.1 km from centre" />
        </div>
        <div className="form-group" style={{display:'flex', alignItems:'center', gap:8}}>
          <input
            name="is_featured"
            type="checkbox"
            id="is_featured_chk"
            checked={!!form.is_featured}
            onChange={e => setForm(f => ({...f, is_featured: e.target.checked}))}
            style={{width:'auto',marginTop:20}}
          />
          <label htmlFor="is_featured_chk" style={{marginTop:20, cursor:'pointer'}}>Featured property</label>
        </div>
      </div>
      {error && <p className="error" style={{ color: '#ef4444', marginTop: 8 }}>{error}</p>}
      {success && <p className="success" style={{ color: '#22c55e', marginTop: 8 }}>{success}</p>}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 24 }}>
        <button
          type="submit"
          disabled={saving}
          style={{
            background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            borderRadius: 8,
            padding: '12px 32px',
            fontWeight: 600,
            fontSize: 16,
            boxShadow: '0 2px 8px rgba(102,126,234,0.08)',
            cursor: saving ? 'not-allowed' : 'pointer',
            transition: 'background 0.2s',
            opacity: saving ? 0.7 : 1
          }}
        >
          {saving ? 'Saving...' : 'Save'}
        </button>
      </div>
    </form>
  );
}